import { ButtonProps } from '@toggle/design-system';
import { TFunction } from 'i18next';

export const TRACKING_TOAST_ID = 'insight-tracking-toast';
export const TRACKING_TOAST_SCOPE = 'insight-tracking';

export const getTrackButtonProps = (
  isTracked: boolean,
  t: TFunction
): ButtonProps => ({
  variant: isTracked ? 'secondary' : 'primary',
  iconName: isTracked ? 'Checkmark' : 'Bell',
  label: isTracked ? t('insights:drawer.tracking') : t('insights:drawer.track'),
  size: 'small',
});
